import React, { useMemo } from 'react';

import { Autocomplete, TextField } from '@mui/material';

import { getCountryNames } from '@luxuryescapes/lib-countries';

interface Props {
  value: string;
  onChange: (newValue: string) => void;
  onFocus?: () => void;
}

export default function AccommodationCountryFilterInput({ value, onChange, onFocus }: Props) {
  const countries = useMemo(() => getCountryNames().sort(), []);

  return (
    <Autocomplete
      options={countries}
      value={value || null}
      onChange={(_, newValue) => onChange(newValue ?? '')}
      renderInput={(params) => <TextField {...params} label="Country" onFocus={onFocus} />}
      fullWidth
      openOnFocus
      clearOnEscape
    />
  );
}
